import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

const LoadingWrapperBase = styled.div`
  position: relative;
`;

const LoadingIndicatorWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.75);
`;

const LoadingMessage = styled(Typography)`
  && {
    margin-top: ${props => props.theme.spacing(2)}px;
  }
`;

const LoadingWrapper = ({
  children,
  isLoading,
  message,
  loadingElement: LoadingElement,
  ...props
}) => (
  <LoadingWrapperBase {...props}>
    {isLoading && (
      <LoadingIndicatorWrapper>
        <LoadingElement />
        {message && (
          <LoadingMessage variant="caption" color="textSecondary">
            {message}
          </LoadingMessage>
        )}
      </LoadingIndicatorWrapper>
    )}
    {children}
  </LoadingWrapperBase>
);

LoadingWrapper.propTypes = {
  loadingElement: PropTypes.any,
  isLoading: PropTypes.bool,
  children: PropTypes.any,
  message: PropTypes.string,
};

LoadingWrapper.defaultProps = {
  loadingElement: CircularProgress,
  isLoading: false,
  children: null,
  message: null,
};

export default LoadingWrapper;
